import React from "react";

export default function NotFoundPage() {
  return (
    <div className="flex justify-center items-center h-96 text-6xl">
      <h1>Error 404</h1>
    </div>
  );
}
